import { Link } from 'react-router-dom';

import RelativeTime from '../../../common/components/relative-time/relative-time';
import StatusPill from '../../../common/components/status-pill/status-pill';
import { AGENT_STATUS_LABEL, AGENT_STATUS_TONE, PROVIDER_LABEL } from '../../../core/constants/domain';
import { ROUTES } from '../../../core/constants/routes';
import { leaseProgress } from '../utils/summary';

import '../styles/running-work.css';

export default function RunningWork({ seats }) {
    return (
        <ul className="running-work">
            {seats.map(({ seat, status }) => {
                const progress = leaseProgress(seat.task);
                return (
                    <li key={seat.id} className="running-work__card">
                        <div className="running-work__head">
                            <span className="running-work__agent">{seat.label}</span>
                            <StatusPill tone={AGENT_STATUS_TONE[status]}>{AGENT_STATUS_LABEL[status]}</StatusPill>
                        </div>
                        {seat.task ? (
                            <Link to={ROUTES.TASK(seat.task.id)} className="running-work__task">{seat.task.title}</Link>
                        ) : (
                            <p className="running-work__task running-work__task--none">Sin tarea en ejecución</p>
                        )}
                        {progress != null && (
                            <div
                                className={`running-work__lease${progress >= 1 ? ' running-work__lease--expired' : ''}`}
                                role="img"
                                aria-label={progress >= 1 ? 'Reserva vencida' : `Reserva usada al ${Math.round(progress * 100)} %`}
                            >
                                <span className="running-work__lease-fill" style={{ width: `${Math.min(progress, 1) * 100}%` }} />
                            </div>
                        )}
                        <p className="running-work__meta">
                            <span>{PROVIDER_LABEL[seat.provider] ?? seat.provider}</span>
                            <span>Última señal <RelativeTime value={seat.lastSeenAt} /></span>
                        </p>
                    </li>
                );
            })}
        </ul>
    );
}
